import { render, staticRenderFns } from "./ProductAiDrawer.vue?vue&type=template&id=6d5fa823&scoped=true"
import script from "./ProductAiDrawer.vue?vue&type=script&lang=js"
export * from "./ProductAiDrawer.vue?vue&type=script&lang=js"
import style0 from "./ProductAiDrawer.vue?vue&type=style&index=0&id=6d5fa823&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5fa823",
  null
  
)

export default component.exports